<!--
 * @Description: 
 * @Date: 2021-12-14 11:47:54
-->
<template>
  <iframe
    :src="
      '//cdn.yxvzb.com/WEB/static-html/ysh_logoff_agreement.html?t=' +
        Date.now()
    "
    frameborder="0"
    width="100%"
    style="height:100vh"
  ></iframe>
</template>

<script>
export default {
  name: 'PersonalLogOffAgreement'
};
</script>
